export default __webpack_public_path__ + "static/blogNineImage_featuredImage-774b25856a750c70f95169699e47c5c8.webp";